import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getCategory } from '../data/calculators';
import { CALC_REGISTRY } from '../calculators/registry';
import { ArrowRight, Search, ArrowLeft } from 'lucide-react';

export default function CategoryPage() {
  const { categoryId } = useParams();
  const cat = getCategory(categoryId);
  const [q, setQ] = useState('');

  if (!cat) return <div>Category not found</div>;

  const filtered = cat.tools.filter(t => t.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-blue-600 mb-4"><ArrowLeft className="w-4 h-4" /> Home</Link>
      <h1 className="text-3xl font-extrabold text-slate-900 mb-2">{cat.name}</h1>
      <p className="text-slate-600 mb-6">{cat.description}</p>

      <div className="relative max-w-md mb-6">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Filter tools..."
          className="pl-9 pr-3 py-2 text-sm bg-white border border-slate-200 rounded-full w-full outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map(tool => {
          const isImpl = !!CALC_REGISTRY[tool.slug];
          return (
          <Link
            key={tool.slug}
            to={`/calc/${tool.slug}`}
            className="group px-4 py-3 rounded-xl bg-white border border-slate-200 hover:shadow-md hover:border-blue-400 transition-all text-sm font-medium text-slate-700 flex items-center gap-3"
            data-testid={`cat-tool-${tool.slug}`}
          >
            <img
              src={`/icons/${tool.slug}.png`}
              alt=""
              onError={(e) => { e.currentTarget.src = '/icons/_fallback.png'; }}
              className="w-11 h-11 object-contain flex-shrink-0 bg-slate-50 border border-slate-200 rounded-lg p-1"
            />
            <span className="flex-1 line-clamp-2">{tool.name} {!isImpl && <span className="text-xs text-orange-500 ml-1">(soon)</span>}</span>
            <ArrowRight className="w-4 h-4 text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
          </Link>
          );
        })}
      </div>
    </div>
  );
}
